module.exports = {
	"id": "BS",
	"name": "Bahamas",
	"month": "2016-10",
	"access_date": "2016-11-03",
	"data": {
		"chrome": {
			"4": null,
			"5": null,
			"6": null,
			"7": null,
			"8": null,
			"9": null,
			"10": null,
			"11": 0.026665,
			"12": 0.005333,
			"13": null,
			"14": null,
			"15": null,
			"16": null,
			"17": null,
			"18": 0.031998,
			"19": null,
			"20": null,
			"21": null,
			"22": 0.005333,
			"23": null,
			"24": null,
			"25": null,
			"26": null,
			"27": null,
			"28": null,
			"29": 0.010666,
			"30": 0.015999,
			"31": 0.015999,
			"32": 0.005333,
			"33": 0.042664,
			"34": 0.015999,
			"35": 0.005333,
			"36": 0.021332,
			"37": 0.015999,
			"38": 0.05333,
			"39": 0.042664,
			"40": 0.010666,
			"41": 0.021332,
			"42": 0.010666,
			"43": 0.117326,
			"44": 0.031998,
			"45": 0.015999,
			"46": 0.021332,
			"47": 0.026665,
			"48": 0.010666,
			"49": 1.498573,
			"50": 0.15999,
			"51": 0.858613,
			"52": 0.463971,
			"53": 18.404183,
			"54": 5.556986,
			"55": 0.042664,
			"56": null,
			"57": null
		},
		"firefox": {
			"2": null,
			"3": null,
			"4": 0.005333,
			"5": null,
			"6": null,
			"7": null,
			"8": null,
			"9": 0.005333,
			"10": null,
			"11": null,
			"12": 0.010666,
			"13": 0.005333,
			"14": null,
			"15": null,
			"16": 0.015999,
			"17": null,
			"18": null,
			"19": null,
			"20": null,
			"21": null,
			"22": null,
			"23": null,
			"24": 0.015999,
			"25": null,
			"26": null,
			"27": null,
			"28": null,
			"29": null,
			"30": null,
			"31": 0.010666,
			"32": 0.021332,
			"33": 0.010666,
			"34": null,
			"35": null,
			"36": null,
			"37": null,
			"38": 0.042664,
			"39": 0.010666,
			"40": 0.010666,
			"41": 0.021332,
			"42": 0.026665,
			"43": 0.074662,
			"44": 0.037331,
			"45": 0.085328,
			"46": 0.10666,
			"47": 0.31998,
			"48": 0.517301,
			"49": 3.290461,
			"50": 0.047997,
			"51": null,
			"52": null,
			"3.5": null,
			"3.6": null
		},
		"opera": {
			"9": null,
			"11": null,
			"12": null,
			"15": null,
			"16": null,
			"17": null,
			"18": null,
			"19": null,
			"20": null,
			"21": null,
			"22": null,
			"23": null,
			"24": null,
			"25": null,
			"26": null,
			"27": 0.005333,
			"28": null,
			"29": 0.042664,
			"30": null,
			"31": null,
			"32": null,
			"33": 0.021332,
			"34": null,
			"35": null,
			"36": null,
			"37": 0.170656,
			"38": 0.149324,
			"39": null,
			"40": 0.149324,
			"41": 0.015999,
			"42": null,
			"43": null,
			"9.5-9.6": null,
			"10.0-10.1": 0,
			"10.5": null,
			"10.6": null,
			"11.1": null,
			"11.5": null,
			"11.6": null,
			"12.1": null
		},
		"safari": {
			"0": null,
			"4": 0.037331,
			"5": 0.058663,
			"6": 0.021332,
			"7": 0.042664,
			"8": 0.207987,
			"9": 0.245318,
			"10": 1.43991,
			"3.1": null,
			"3.2": null,
			"5.1": 0.255984,
			"6.1": 0.069329,
			"7.1": 0.005333,
			"9.1": 1.125263
		},
		"ios_saf": {
			"8": 0,
			"10": 7.60897809742,
			"3.2": 0,
			"4.0-4.1": 0,
			"4.2-4.3": 0,
			"5.0-5.1": 0,
			"6.0-6.1": 0,
			"7.0-7.1": 0.205053155183,
			"8.1-8.4": 0.378827015508,
			"9.0-9.2": 0.180724814738,
			"9.3": 2.75721191715
		},
		"android": {
			"3": 0,
			"4": 0.0630587674419,
			"53": null,
			"2.1": 0,
			"2.2": 0,
			"2.3": 0.00788234593023,
			"4.1": 0.227461982558,
			"4.2-4.3": 0.568654956395,
			"4.4": 1.30396522674,
			"4.4.3-4.4.4": 1.31522572093
		},
		"ie": {
			"6": null,
			"7": 0.015999,
			"8": 0.277316,
			"9": 0.250651,
			"10": 0.383976,
			"11": 6.138283,
			"5.5": null
		},
		"op_mob": {
			"0": 0.0392655371674,
			"10": 0,
			"11": 0,
			"12": 0,
			"11.1": 0,
			"11.5": 0,
			"12.1": 0.00109070936576
		},
		"edge": {
			"12": 0.207987,
			"13": 1.151928,
			"14": 3.274462
		},
		"ie_mob": {
			"10": 0.160124112676,
			"11": 0.651933887324
		},
		"bb": {
			"7": 0.0490035,
			"10": null
		},
		"samsung": {
			"0": 8.643284
		},
		"and_uc": {
			"0": 0.238017
		},
		"op_mini": {
			"0": 0.529017753467
		},
		"and_chr": {
			"0": 25.755251
		},
		"and_ff": {
			"0": 0.051337
		}
	},
	"total": 98.7590335
};


/*****************
 ** WEBPACK FOOTER
 ** ./~/caniuse-db/region-usage-json/BS.json
 ** module id = 484
 ** module chunks = 0
 **/